import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";
import { ColumnContainer } from "utils/columnsStyle";
import {
  editSgcConfigurationsMode,
  sgcConfigurationSelected,
  deleteSgcConfigurationsMode
} from "redux/actions/sgcConfigurations/sgcConfigurationsAction";

const typeOptions = [
  { value: "STRING", label: "STRING" },
  { value: "BOOLEAN", label: "BOOLEAN" },
  { value: "INTEGER", label: "INTEGER" },
  { value: "DOUBLE", label: "DOUBLE" },
];

const style = {
  color: "#004F9F",
  fontSize: 20,
  marginRight: 10,
  cursor: "pointer"
};

const configTable = [
  {
    Header: "Nombre",
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) => row.name?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Tipo",
    accessor: "type",
    filterable: true,
    filterMethod: (filter, row) => row.type?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Valor",
    accessor: "value",
    filterable: true,
    filterMethod: (filter, row) => row.value?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Valor Por Defecto",
    accessor: "defaultValue",
    filterable: true,
    filterMethod: (filter, row) => row.default_value?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Planta",
    accessor: "station",
    filterable: true,
    filterMethod: (filter, row) => row.station?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Descripción",
    accessor: "description",
    filterable: true,
    filterMethod: (filter, row) => row.description?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Acciones",
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const { rules } = useSelector(({ login }) => login);
      const openEdit = () => {
        dispatch(editSgcConfigurationsMode());
        original.modal(true);
        dispatch(sgcConfigurationSelected(original.id));
      };
      const openEliminate = () => {
        dispatch(deleteSgcConfigurationsMode());
        original.modal(true);
        dispatch(sgcConfigurationSelected(original.id));
      };

      return (
        <ColumnContainer>
          <EditIcon style={style} onClick={openEdit} />
          {
            rules.includes("SGC-CONFIG-DELETE") && <DeleteIcon style={{ ...style, color: "#e83737" }} onClick={openEliminate} />
          }
        </ColumnContainer>
      );
    },
  },
];

export { configTable, typeOptions };
